export const GET_LEVEL_UP_REWARDS = "GET_LEVEL_UP_REWARDS";
export const EDIT_LEVEL_UP_REWARD = "EDIT_LEVEL_UP_REWARD";
export const DELETE_LEVEL_UP_REWARD = "DELETE_LEVEL_UP_REWARD";
export const ADD_LEVEL_UP_REWARD = "ADD_LEVEL_UP_REWARD";

export const OPEN_LEVEL_UP_REWARD_DIALOG = "OPEN_LEVEL_UP_REWARD_DIALOG";
export const CLOSE_LEVEL_UP_REWARD_DIALOG = "CLOSE_LEVEL_UP_REWARD_DIALOG";
